// userApiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.utkarsita.com/api/v1',
    
    credentials: 'include',
  }),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    generateAndStoreOTP: builder.mutation({
      query: (body) => ({
        url: '/generateAndStoreOTP',
        method: 'POST',
        body,
      }),
    }),
    verifyOTP: builder.mutation({
      query: (body) => ({
        url: '/verifyOTP',
        method: 'POST',
        body,
      }),
    }),
    signupUser: builder.mutation({
      query: (body) => ({
        url: '/signup',
        method: 'POST',
        body,
      }),
    }),
    loginUser: builder.mutation({
      query: (body) => ({
        url: '/login',
        method: 'POST',
        body,
      }),
    }),
    logoutUser: builder.mutation({
      query: () => '/logoutUser',
      method: 'POST',
    }),
    getCurrentUser: builder.query({
      query: () => `/user/current-user`, // Adjust the path for search API
    }),
  }),
});

export const {
  useGenerateAndStoreOTPMutation,
  useVerifyOTPMutation,
  useSignupUserMutation,
  useLoginUserMutation,
  useLogoutUserMutation,
  useLazyGetCurrentUserQuery
} = userApi;
